module.exports = __webpack_public_path__ + "media/images/flags/null-f0714d30d0120dd7694ed5e7f549f556.svg";